import { BaseModel } from '../base-model';

export interface IPersonConfigurations {
  AutomaticUpdateIdent?: boolean
  ReferenceFormat?: string
  HasCheckRequiredInPersonDetail?: boolean
}
export class PersonConfigurations extends BaseModel<IPersonConfigurations> implements IPersonConfigurations {
  AutomaticUpdateIdent?: boolean
  ReferenceFormat?: string
  HasCheckRequiredInPersonDetail?: boolean
  /**
   *
   */
  constructor(option?: IPersonConfigurations) {
    super(option)
    this.AutomaticUpdateIdent = this.AutomaticUpdateIdent || null;
    this.AutomaticUpdateIdent = this.AutomaticUpdateIdent || null;
    this.ReferenceFormat = this.ReferenceFormat|| "{CompanyName}, {Name} {FirstName}"
  }
}